var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSentShowcasesEs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 130,
    viewBox: "0 0 131 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.47 35.7394L99.7159 25.9012L53.8107 65.8783L53.47 35.7394Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8588 33.8508L97.4931 26.0206L94.0382 27.4768C89.4852 29.3959 83.412 31.956 77.3309 34.5198C66.3243 39.1604 55.2513 43.8304 53.1676 44.7163L38.8588 33.8508Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7699 48.9235L54.369 65.4238L58.8939 50.0483L73.7699 48.9235Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6351 26.7831L74.1572 60.5966L59.5247 49.5521L99.6351 26.7831Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2232 64.4727C9.66341 93.9727 16.6408 117.853 58.7006 107.353",
    stroke: "black",
    strokeWidth: 1.2,
    strokeDasharray: "1.47 1.47"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9335 71.943C58.9335 69.646 60.7956 67.7839 63.0926 67.7839H88.0335C90.3305 67.7839 92.1926 69.646 92.1926 71.943V107.95C92.1926 110.679 89.9803 112.891 87.2513 112.891H63.8748C61.1458 112.891 58.9335 110.679 58.9335 107.95V71.943Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7001 69.9921H72.9231C72.825 69.9921 72.7458 69.8527 72.7458 69.68C72.7458 69.5073 72.825 69.3679 72.9231 69.3679H79.7001C79.7982 69.3679 79.8774 69.5073 79.8774 69.68C79.8774 69.8527 79.7982 69.9921 79.7001 69.9921Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 78.923H65.7734V79.5368H87.5V78.923Z",
    fill: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8774 81.6061H65.7734V82.2199H79.8774V81.6061Z",
    fill: "#333333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 84.2889H65.5V84.9026H87.5V84.2889Z",
    fill: "#333333"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3115 91.0479C71.9115 91.0479 68.3447 94.6146 68.3447 99.0146C68.3447 103.415 71.9115 106.981 76.3115 106.981C80.7116 106.981 84.2783 103.415 84.2783 99.0146C84.2783 94.6146 80.7116 91.0479 76.3115 91.0479ZM76.3107 94.6345C76.5474 94.6345 76.7621 94.7737 76.8577 94.99L79.8452 101.758C79.9791 102.06 79.8422 102.413 79.5403 102.546C79.4622 102.581 79.3803 102.597 79.2999 102.597C79.0704 102.597 78.8513 102.464 78.7529 102.24L78.2021 100.993C78.1702 100.998 78.1375 101.003 78.1041 101.003H74.519C74.4855 101.003 74.4532 100.999 74.421 100.993L73.8701 102.24C73.7375 102.542 73.3839 102.679 73.0828 102.545C72.7809 102.412 72.6436 102.06 72.777 101.758L75.7646 94.99C75.8602 94.7737 76.0741 94.6345 76.3107 94.6345ZM76.3115 96.7117L74.9446 99.8082H77.6785L76.3115 96.7117Z",
    fill: "#32BEB0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3372 69.079C61.3372 66.4506 63.4679 64.3199 66.0963 64.3199H91.0372C93.6655 64.3199 95.7963 66.4506 95.7963 69.079V105.086C95.7963 108.146 93.3153 110.627 90.255 110.627H66.8784C63.8181 110.627 61.3372 108.146 61.3372 105.086V69.079Z",
    fill: "#98A9FF",
    fillOpacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentShowcasesEs);
export default __webpack_public_path__ + "static/media/sent-showcases-es.d8890efbdb555887eaba08fb33762e7b.svg";
export { ForwardRef as ReactComponent };